import type { SupportedLocaleType } from '@pushflow/constants'
import { atomWithStorage } from 'jotai/utils'

export enum ETableColor {
  GREEN = 'GREEN',
  RED = 'RED',
  BLUE = 'BLUE',
  BLACK = 'BLACK',
}

export enum ECardType {
  DEFAULT = 'DEFAULT',
  COLORED_SYMBOLS = 'COLORED_SYMBOLS',
  COLORED_CANVAS = 'COLORED_CANVAS',
}

export enum ECardBack {
  RED = 'RED',
  BLACK = 'BLACK',
  LIGHT_BLUE = 'LIGHT_BLUE',
  GREEN = 'GREEN',
  BLUE = 'BLUE',
  BROWN = 'BROWN',
}

const defaultValue = {
  langCode: null as SupportedLocaleType | null,
  volume: 100,
  showAutoMoveCheckboxes: true,
  showGameChat: true,
  valuesInBigBlinds: false,
  tableSettings: {
    tableColor: ETableColor.GREEN,
    cardsType: ECardType.DEFAULT,
    cardsBack: ECardBack.RED,
  },
}

export const userSettingsAtom = atomWithStorage('settings', defaultValue)
